export default __webpack_public_path__ + "18f44a4303518cfbeb364e0bffdd79c3.svg";